import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/fluidos/vector_negro.png")